export const ICONS_PATH = '/assets/images/icons/'
export const ICONS_SOCIAL_PATH = '/assets/images/icons/socials/'

const IMAGE_BASE_PATH = '/assets/v2/images/'
const ICON_PATH_BASE = '/assets/v2/images/icons/'

export const DEFAULT_AVATAR =
  'https://storage.googleapis.com/profilepagev1.appspot.com/avatars/defaults/Group%2039926.png'

// inteface of social icons

export const SOCIAL_ICONS = {
  facebook: 'facebook-icon.png',
  twitter: 'twitter-icon.png',
  instagram: 'instagram-icon.png',
  youtube: 'youtube-icon.png',
  linkedin: 'linkedin-icon.png',
  pinterest: 'pinterest-icon.png',
  tiktok: 'tiktok-icon.png',
  twitch: 'twitch-icon.png',
  discord: 'discord-icon.png',
  snapchat: 'snapchat-icon.png',
  spotify: 'spotify-icon.png',
  telegram: 'telegram-icon.png',
  onlyfans: 'onlyfans-icon.png',
  website: 'website-icon.png',
  beehiiv: 'beehiiv-icon.png',
  substack: 'substack-icon.png',
  imdb: 'imdb-icon.png',
  behance: 'behance-icon.png',
}

export const GRAY_SOCIAL_ICONS = {
  facebook: 'facebook-gray-icon.png',
  twitter: 'twitter-gray-icon.png',
  instagram: 'instagram-gray-icon.png',
  youtube: 'youtube-gray-icon.png',
  linkedin: 'linkedin-gray-icon.png',
  pinterest: 'pinterest-gray-icon.png',
  tiktok: 'tiktok-gray-icon.png',
  twitch: 'twitch-gray-icon.png',
  discord: 'discord-gray-icon.png',
  snapchat: 'snapchat-gray-icon.png',
  spotify: 'spotify-gray-icon.png',
  telegram: 'telegram-gray-icon.png',
  onlyfans: 'onlyfans-gray-icon.png',
  website: 'website-gray-icon.png',
  beehiiv: 'beehiiv-gray-icon.png',
  substack: 'substack-gray-icon.png',
  imdb: 'imdb-gray-icon.png',
  behance: 'behance-gray-icon.png',
}

export const ICONS_PATHS_V2 = {
  socials: ICON_PATH_BASE + 'social/',
  commons: ICON_PATH_BASE,
}

export const IMAGE_PATHS_V2 = {
  icons: ICONS_PATHS_V2,
  bg: IMAGE_BASE_PATH + 'backgrounds/',
  logos: IMAGE_BASE_PATH + 'logos/',
  samples: IMAGE_BASE_PATH + 'samples/',
  creatorsCard: IMAGE_BASE_PATH + 'creators_cards/',
  testimonials: IMAGE_BASE_PATH + 'testimonials/',
  profileDemo: IMAGE_BASE_PATH + 'profile_demo/',
  projects: IMAGE_BASE_PATH + 'projects/',
  system: IMAGE_BASE_PATH + 'default_system_images/',
  analytics: IMAGE_BASE_PATH + 'analytics/',
  search: IMAGE_BASE_PATH + 'search/',
  landing: IMAGE_BASE_PATH + 'landing/',
  profileV2: IMAGE_BASE_PATH + 'profile_v2/',
  home: IMAGE_BASE_PATH + 'home/',
  staffPicks: IMAGE_BASE_PATH + 'staffpicks/',
  profileViews: IMAGE_BASE_PATH + 'profile-views/',
  jobs: IMAGE_BASE_PATH + 'jobs/',
  dealSync: IMAGE_BASE_PATH + 'deal-sync/',
}
